const currentScript =
  document.currentScript ||
  (function () {
    let scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].src.match(/js\/bundle.js/)) return scripts[i];
    }
  })();

const STAGING = currentScript.getAttribute('staging');
const APP_REACT = currentScript.getAttribute('apptype') == 'react';

const devApiUrl = 'https://localhost:44358/api/';
const testApiUrl = 'https://bbapiwebapptest.azurewebsites.net/api/';
const prodApiUrl = 'https://bbapiwebappprod.azurewebsites.net/api/';
const stagingApiUrl = 'https://bbapiwebappstaging.azurewebsites.net/api/';

const apiURL =
  STAGING == 'prod' ? prodApiUrl : STAGING == 'test' ? testApiUrl : STAGING == 'staging' ? stagingApiUrl : devApiUrl;

export const appConfig = {
  APP_REACT: APP_REACT,

  devApiUrl: devApiUrl,
  testApiUrl: testApiUrl,
  prodApiUrl: prodApiUrl,
  stagingApiUrl: stagingApiUrl,

  apiURL: apiURL,

  wssURL: process.env.NEXT_PUBLIC_WWS,

  productionUrl: 'https://bbstaticwebappprod.azurewebsites.net/',
  testUrl: 'https://bbstaticwebapptest.azurewebsites.net/',

  eulaFiles: {
    path: '/eula/',
    ULA: 'UserLicenseAgreement.html',
    CP: 'CookiePolicy.html',
    IPP: 'IntellectualPropertyPolicy.html',
    PP: 'PrivacyPolicy.html',
    TOU: 'TermsofUse.html'
  },

  fantecAdmin: ['admin@f4ntec.com'],
  generalAdmins: ['admin@f4ntec.com', 'admin@brandbow.com'],

  // Routing
  routing: {
    settings: {
      root: null,
      /*useHash: true,
      hash: '#!'*/
      useHash: false
    },
    startpage: 'blanks'
  },

  // Date formats
  appDateFormat: 'DD.MM.YYYY',
  appFullDateFormat: 'MMM DD, YYYY',

  clientTimeOut: 1000 * 60 * 60 * 3, // 1min * 60 * 3 = 3 hour

  GLOBAL: {
    UNSAVED_CHANGES: 'unsaved_changes'
  },

  default: {
    page: 'blanks'
  },

  filter: {
    moneyRange: [0, 300]
  },

  colorVariantsInCard: 8,

  fileTemplates: {
    bomImportFull: {
      link: 'File/getSignedUri?&FileName=bom_template.xlsx&FolderName=templates&ContainerName=import&FileSize=Small',
      name: 'BomImport_full_template'
    },
    bomImportLean: {
      link:
        'File/getSignedUri?&FileName=bom_lean_template.xlsx&FolderName=templates&ContainerName=import&FileSize=Small',
      name: 'BomImport_lean_template'
    },
    orderImport: {
      link: 'File/getSignedUri?&FileName=order_template.xlsx&FolderName=templates&ContainerName=import&FileSize=Small',
      name: 'OrdersImport_template'
    },
    artworksBulkImport: {
      template: {
        link: 'File/getSignedUri?&FileName=artworks_import_template.xlsx&FolderName=templates&ContainerName=import&FileSize=Small',
        name: 'artworks_import_template'
      },
      tutorial: {
        link: 'File/getSignedUri?&FileName=artworks_import_template_tutorial.xlsx&FolderName=templates&ContainerName=import&FileSize=Small',
        name: 'artworks_import_template_tutorial'
      }
    }
  },

  storagekey: {
    userID: 'bbw_userid',
    userauth: 'bbw_auth',
    selectaccountid: 'bbw_select_account_id',
    selectedLicensors: 'bbw_selected_licensors',
    syncedFilters: 'bbw_syncedFilters',
    licensee: 'bbw_licensee',
    licensor: 'bbw_licensor',
    isLicensor: 'bbw_is_licensor',
    userContext: 'bbw_user_context',
    userdata: 'bbw_userdata',
    accountdata: 'bbw_accountdata',
    accountsdata: 'bbw_accountsdata',
    currentAccountID: 'bbw_current_account_id',
    listenNotificationFrom: 'bbw_listen_notification_from',
    brandbowApiVersion: 'brandbow_api_version'
  },

  paging: {
    pagelimit: {
      default: screen.height < 900 ? 6 : 9, // Hack for Dror, прости г-ди
      blanks: screen.height < 900 ? 6 : 10,
      myblanks: screen.height < 900 ? 6 : 10,
      //prelisting: screen.height < 900 ? 6 : 9,
      prelistings: 6,
      orders: 10,
      listings: screen.height < 900 ? 6 : 10,
      artworks: screen.height < 900 ? 6 : 9,
      trims: screen.height < 900 ? 6 : 9,
      styleGuides: screen.height < 900 ? 6 : 9,
      customerAccount: screen.height < 900 ? 18 : 27,
      briefs: screen.height < 900 ? 6 : 9
    }
  },

  // Different method for get accounts (with All-All)
  accountsPerPages: ['orders'],

  pagedatakey: {
    root: 'DT',
    pagedata: 'pagedata',
    originaldata: 'originaldata',
    userdata: 'userdata'
  },

  itemRelatedProductsActionType: {
    ConfirmMockups: 0,
    ConfirmListings: 1,
    DeleteMockups: 2,
    DeleteListings: 3
  },

  approveType: {
    default: 0,
    approved: 1,
    disapproved: 2
  },

  externalSourceType: {
    default: 0,
    bulkUpload: 1,
    exBom: 2
  },

  approveTypeName: {
    default: 'Default',
    approved: 'Approved',
    disapproved: 'Disapproved'
  },

  currencySymbol: {
    USD: '$',
    CAD: '$',
    AUD: '$',
    EUR: '€',
    EU: '€',
    EURO: '€',
    NIS: '₪'
  },

  uploadFileMaxSize: 20, // - max size file uploading in Mb
  uploadFileChunkSize: 5, // - max size file uploading in Mb

  fileTypes: {
    pngLow: 0,
    pngHigh: 1,
    aiPsd2: 2,
    vectorPdf: 3,
    other: 4,
    aiPsd6: 6,
    ambiencePhotos: 9,
    font: 11,
    aiPsd12: 12,
    ripTif: 14,
    pngHigh15: 15,
    thumbnailPngFromVector: 22,
    pngFromVector: 23,
  },

  filesModel: {
    1: {
      typeTitle: 'PNG high resolution file',
      fileType: 1,
      limit: 1,
      extensions: ['png'],
      //imageSize: {w: 4251, h: 5669},
      imageSize: { w: 150, h: 150 },
      areaFull: null,
      areaOptimal: null,
      areaPocket: null,
      DPI: 150,
      description: '* Mandatory for creating mockups and thumbnail',
      order: 1,
      showSuitability: true,
      suitabilityViewExtensions: ['png'],
      canbesource: true // This file type we can use as source file for genarate mockups
    },
    12: {
      typeTitle: 'Ai / PSD file',
      fileType: 12,
      limit: 1,
      extensions: ['ai', 'psd'],
      description: '* Mandatory for Screen Print',
      order: 2,
      showSuitability: true,
      suitabilityViewExtensions: ['psd'],
      canbesource: true // This file type we can use as source file for genarate mockups
    },
    3: {
      typeTitle: 'Vector PDF',
      fileType: 3,
      limit: 1,
      extensions: ['pdf'],
      order: 3,
      showSuitability: false,
      suitabilityViewExtensions: [],
      canbesource: true // This file type we can use as source file for genarate mockups
    },
    14: {
      typeTitle: 'Rip TIF file',
      fileType: 14,
      limit: 1,
      extensions: ['tif', 'tiff'],
      imageSize: { w: 4251, h: 5669 },
      order: 4,
      showSuitability: true,
      suitabilityViewExtensions: ['tif', 'tiff'],
      canbesource: true // This file type we can use as source file for genarate mockups
    },
    11: {
      typeTitle: 'Font files',
      fileType: 11,
      limit: 20,
      extensions: ['ttf', 'otf', 'svg', 'eot', 'woff', 'woff2'],
      order: 5,
      showSuitability: false,
      suitabilityViewExtensions: []
    },
    4: {
      typeTitle: 'Other file',
      fileType: 4,
      extensions: null,
      order: 6,
      showSuitability: false,
      suitabilityViewExtensions: []
    },
    0: {
      typeTitle: 'PNG low resolution file',
      fileType: 0,
      limit: 1,
      extensions: ['png'],
      imageSize: { w: 600, h: 600 },
      auto: true,
      description: '* Auto-created for thumbnail',
      order: 7,
      showSuitability: false,
      suitabilityViewExtensions: []
    },
    15: {
      typeTitle: 'PNG high resolution file',
      fileType: 15,
      extensions: ['png'],
      auto: true,
      order: 8,
      showSuitability: true,
      suitabilityViewExtensions: ['png']
    },
    2: {
      typeTitle: 'Ai / PSD file',
      fileType: 2,
      limit: 1,
      extensions: ['ai', 'psd'],
      auto: true,
      description: '* Mandatory for Screen Print',
      order: 9,
      showSuitability: true,
      suitabilityViewExtensions: ['psd']
    },
    // TODO FileTipes from MPD addFiles
    9: {
      typeTitle: 'Product Ambience Photos .PNG file High Res.',
      auto: true,
      fileType: 9,
      extensions: ['png'],
      order: 10,
      showSuitability: true,
      suitabilityViewExtensions: ['png']
    },
    6: {
      typeTitle: 'Ai / PSD file',
      auto: true,
      fileType: 6,
      limit: 1,
      extensions: ['ai', 'psd'],
      description: '* Mandatory for Screen Print',
      order: 11,
      showSuitability: true,
      suitabilityViewExtensions: ['psd']
    },
    /*
     **  BRAN-1970 - store data - add external mockup - indicates png but requires pdf
     **  https://brandbow.atlassian.net/browse/BRAN-1970
     */
    DesignedArtworkThumbnail: {
      typeTitle: 'Designed Artwork Thumbnail .PNG file',
      fileType: 3,
      limit: 1,
      extensions: ['png'],
      order: 3,
      showSuitability: false,
      suitabilityViewExtensions: []
    },
    screenprintFiles: {
      typeTitle: 'Supported image files',
      fileType: 15,
      extensions: ['png', 'ai', 'psd', 'pdf', 'tif', 'tiff'],
      auto: true,
      order: 8,
      showSuitability: false,
      suitabilityViewExtensions: []
    },
    22: {
      typeTitle: 'AOP generated file thumbnail',
      fileType: 0,
      limit: 1,
      extensions: ['png'],
      imageSize: { w: 600, h: 600 },
      auto: true,
      description: '* Auto-created for thumbnail',
      order: 7,
      showSuitability: false,
      suitabilityViewExtensions: []
    },
    23: {
      typeTitle: 'AOP generated file large',
      fileType: 1,
      limit: 1,
      extensions: ['png'],
      //imageSize: {w: 4251, h: 5669},
      imageSize: { w: 150, h: 150 },
      auto: true,
      areaFull: null,
      areaOptimal: null,
      areaPocket: null,
      DPI: 150,
      description: '* Mandatory for creating mockups and thumbnail',
      order: 1,
      showSuitability: true,
      suitabilityViewExtensions: ['png'],
      canbesource: true // This file type we can use as source file for genarate mockups
    },
  },

  filesPartType: {
    1: { name: 'DTG', value: 1 },
    2: { name: 'ScreenPrint', value: 2 },
    3: { name: 'Source', value: 3 },
    4: { name: 'HeatPrint', value: 4 },
    8: { name: 'Other', value: 8 },
    16: { name: 'Default', value: 16 },
    32: { name: 'AOPFiles', value: 32 }
  },

  aopTransform: {
    pattern: { name: 'Pattern', value: 0 },
    image: { name: 'Image', value: 1 },
    patternWithImage: { name: 'Pattern with Image', value: 2 }
  },

  folderName: {
    artworks: 'Artworks',
    artworksInfo: 'ArtworksInfo',
    trims: 'Trims',
    stamps: 'Stamps',
    orders: 'Orders'
  },

  areasType: {
    full: 1,
    optimal: 2,
    pocket: 3
  },

  notification: {
    processWaitingTimer: 60 * 1000 * 2, // 60 sec*2 = 2 min
    type: [
      { name: 'None', page: '' },
      { name: 'MockupGenerate', page: 'artworks' },
      { name: 'ProductUpload', page: 'prelistings' },
      { name: 'OrderCreate', page: '' },
      { name: 'FileCreate', page: '' },
      { name: 'SubmitBomProcess', page: '' }
    ]
  },

  printMethods: [
    { id: 'DTG', name: 'DTG' },
    { id: 'ScreenPrinting', name: 'Screen printing' }
  ]
};
